<template>
    <form-controll :field="field">
        <template scope="api">
            <v-input-text :readonly="readonly" :mask="mask" :value="api.getValue()" :autocomplete="autocomplete" :type="type" :name="field" @input="api.setValue" @blur="api.setTouched" :caption="caption" :label="label" :error="api.getTouched() ? api.getError() : undefined" :placeholder="placeholder">
                <template slot="error" scope="props"><slot name="error" :error="props.error">{{ props.error }}</slot></template>
                <template slot="caption" scope="props">
                    <slot name="caption">{{ caption }}</slot>
                </template>
            </v-input-text>
        </template>
    </form-controll>
</template>
<script>
import { FormControll } from '../../../../form/components';

export default {
    name: 'sign-form-input',
    props: {
        mask: String,
        autocomplete: String,
        caption: String,
        label: String,
        placeholder: String,
        readonly: Boolean,
        type: {
            type: String,
            default: 'text'
        },
        field: {
            type: String,
            required: true,
        },
    },
    components: {
        FormControll,
    },
}
</script>


// WEBPACK FOOTER //
// FormInput.vue?524d4df0